import { BUTTON_SIZES } from 'ui/button';
import { Refresh16 } from 'ui/icons';
import { AnimRefresh16, StyledRefreshButton } from './Styled';
import { useTranslation } from '../../hooks';
import { useSegmentationQueryContext } from '../../contexts/segmentationQuery';
import { FORM_ID } from '../../constants';
import { SubmitType } from '../../types';

export const testIds = {
  buttonViewResults: 'segmentation-vrb-btn-view-results',
};

export const ViewResultsButton = () => {
  const { t } = useTranslation();
  const { isLoading } = useSegmentationQueryContext();

  return (
    <StyledRefreshButton
      data-test={testIds.buttonViewResults}
      size={BUTTON_SIZES.SMALL}
      type="submit"
      form={FORM_ID}
      id={SubmitType.refresh}
      isDisabled={isLoading}
    >
      <span>{t('button.viewResults')}</span>
      {isLoading ? <AnimRefresh16 /> : <Refresh16 />}
    </StyledRefreshButton>
  );
};
